import React, { useMemo } from 'react';
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from '../../../../../_metronic/_partials/controls';
import { injectIntl } from 'react-intl';
import OrdersFilter from './orders-filter/OrdersFilter';
import OrdersTable from './orders-table/OrdersTable';
import { useOrdersUIContext } from './OrdersUIContext';

const OrdersCard = (props) => {
  const { intl } = props;
  const title = intl.formatMessage({ id: 'ORDER.TITLE.LIST' });
  const ordersUIContext = useOrdersUIContext();
  const ordersUIProps = useMemo(() => {
    return {
      queryParams: ordersUIContext.queryParams,
      setQueryParams: ordersUIContext.setQueryParams,
      openViewOrderDialog: ordersUIContext.openViewOrderDialog,
      openCreateOrderDialog: ordersUIContext.openCreateOrderDialog,
      openDeleteOrdersDialog: ordersUIContext.openDeleteOrdersDialog,
    };
  }, [ordersUIContext]);

  return (
    <Card id='ordersCard'>
      <CardHeader title={title}>
        <CardHeaderToolbar>
          <button
            type='button'
            className='btn btn-primary'
            onClick={ordersUIProps.openCreateOrderDialog}
          >
            Захиалга бүртгэх
          </button>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <OrdersFilter props />
        <OrdersTable props />
      </CardBody>
    </Card>
  );
};

export default injectIntl(OrdersCard);
